<template >

  <div class="el-form-item el-form-item--mini" :class="{ 'is-error': inValid,'form__validated': state.validated, 'user-change': warningChange  }" name="name">
    <slot name="label" :label="label"  >
        <label class="el-form-item__label el-w-100 el-text-left el-visibility-hidden" v-if="hiddenlabel" >lable</label>
        <label class="el-form-item__label el-w-100 el-text-left " v-else >{{ label }}</label>
    </slot>
    <div class="el-form-item__content" :class="{ 'form__valid': state.valid, 'form__invalid': inValid}"> 
      <slot name="content" :label="label"/>
    </div> 
  </div> 
</template>

<script>
import { mapFields } from "vee-validate";
import { log } from 'util';


export default {
  props: {
    label: {
      type: String,
      required: false
    },
    hiddenlabel: {
      type: Boolean,
      required: false
    },
    name: { // should be set if wanna validate - the name that set for BindingField in validate model
      type: String,
      required: false
    },
    scope: { // should be set if wanna validate -  scope that this field belongs to
      type: String,
      required: false
    },
  },
  data() {
      return {}
  },
  computed: {
    state: function() {
        const errorBag = (this.$root.$validator && this.$root.$validator.errors.items) || [];
        if(!this.name || errorBag.length === 0 ) return {};
        // Will not care if it in FE validation set
        // const field = this.$root.$validator.fields.items.find(
        //     c => c.name == this.name && c.scope == this.scope
        //     );
        // if (field == null) return {};

        const errorField = this.$root.$validator.errors.items.find(
            c => c.field == this.name && c.scope == this.scope
        );
        if (errorField != null) { //&& field.flags.invalid == false
            return  {
                validated: true,
                invalid: true,
                valid: false
            }
           
        }
        return {};
    },

    inValid: function(){
      return this.state.validated && this.state.invalid;
    },

    warningChange: function() {
        if(this.$store.state.common['userChangeDataFields'].indexOf(this.name) > - 1) return true;
        return false
    }
  },
  
};
</script>
